import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit01 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1857_2277)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.67767 10.5673C1.70447 10.3261 1.71787 10.2055 1.75436 10.0928C1.78674 9.99277 1.83248 9.89759 1.89035 9.80983C1.95558 9.71092 2.04138 9.62512 2.21299 9.45351L9.91666 1.74985C10.561 1.10552 11.6057 1.10552 12.25 1.74985C12.8943 2.39418 12.8943 3.43885 12.25 4.08319L4.54632 11.7868C4.37471 11.9585 4.28891 12.0443 4.19 12.1095C4.10224 12.1673 4.00707 12.2131 3.90706 12.2455C3.79433 12.282 3.67373 12.2954 3.43253 12.3222L1.45831 12.5415L1.67767 10.5673Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1857_2277",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgEdit01;
